import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import useTabsSystemStore from "../../../store/RenderTabStore";
import ApprovedStatusModal from "../ApprovedStatusModal.js";

const ListRegisterGrid = ({}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { vendorLists, loading, getVendorStatusReport, setEditInStep4 } =
    useVendorMasterStore();
  const { openTabs, addNewTab, setActiveTab } = useTabsSystemStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [guid, setGuid] = useState(null);

  const linkTemplate = (props) => {
    return (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          localStorage.setItem("vendorGUID", props?.VendorGUID);
          localStorage.setItem("submitted", "Yes");
          if (props?.VendorStatus !== "Approved") {
            localStorage.setItem("showApprove", true);
          } else {
            localStorage.setItem("showApprove", false);
          }
          const editInStep4 =
            props?.ApprovalGroupId == 0 && props?.VendorStatus === "Pending";
          setEditInStep4(editInStep4);
          addNewTab([
            ...openTabs,
            {
              closable: true,
              key: "new_registration",
              label: "New Vendor Registration",
            },
          ]);
          setActiveTab("new_registration");
        }}
        style={{
          color: "#1890ff",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {props?.VendorGUID}
      </a>
    );
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const headerStyle = {
    padding: "12px",
    textAlign: "left",
    borderBottom: "2px solid #d9d9d9",
    fontWeight: "600",
    color: "#333",
  };
  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };
  if (Array.isArray(vendorLists) && vendorLists.length > 0) {
    const hasVendorStatusKey = vendorLists.some(
      (item) =>
        item && Object.prototype.hasOwnProperty.call(item, "VendorStatus")
    );

    localStorage.setItem("ShowStep4", hasVendorStatusKey ? "Yes" : "No");
  } else {
    // default fallback
    localStorage.setItem("ShowStep4", "No");
  }

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                Loading vendors...
              </div>
            ) : (
              <GridComponent
                ref={(g) => (gridInstance = g)}
                id="BrokerGrid"
                dataSource={vendorLists}
                allowPaging={true}
                allowSorting={true}
                allowFiltering={true}
                allowResizing={true}
                filterSettings={{ type: "Excel" }}
                toolbar={["ExcelExport", "Search"]}
                allowExcelExport={true}
                toolbarClick={toolbarClick}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
                gridLines="Both"
                height={"300px"}
                pageSettings={{
                  pageSizes: [10, 20, 30, 40, 50, "All"],
                  pageCount: 10,
                }}
                rowHeight={isMobile ? "" : 32}
                dataBound={() => {
                  if (!isMobile && gridInstance) {
                    gridInstance.autoFitColumns(); 
                  }
                }}
                // frozenColumns={1}
                // rowDataBound={()}
                commandClick={async (args) => {
                  const row = args?.rowData;
                  if (!row?.VendorGUID) return;
                  await getVendorStatusReport(row.VendorGUID);
                  setGuid(row.VendorGUID);
                  setModalOpen(true);
                }}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="serialNo"
                    headerText="S No"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorGUID"
                    headerText="GUID"
                    textAlign="Left"
                    template={linkTemplate}
                  />
                  <ColumnDirective
                    field="VendorName"
                    headerText="Vendor Name"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="EmailID"
                    headerText="Email"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorStatus"
                    headerText="Vendor Status"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="StatusOn"
                    headerText="Status On"
                    textAlign="Left"
                    type="date"
                    format="dd/MM/yyyy"
                  />
                  <ColumnDirective
                    field="StatusRemark"
                    headerText="Status Remark"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="CreatedOn"
                    headerText="Created On"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    headerText="Actions"
                    textAlign="Center"
                    freeze="Right"
                    commands={[
                      {
                        type: "None",
                        buttonOption: {
                          iconCss: "e-icons e-eye",
                          cssClass: "e-flat e-primary",
                        },
                      },
                    ]}
                    showInAdaptiveUI={false}
                  />
                </ColumnsDirective>

                <Inject
                  services={[
                    CommandColumn,
                    Page,
                    Filter,
                    Toolbar,
                    ExcelExport,
                    Sort,
                    Group,
                    Resize,
                    Freeze,
                  ]}
                />
              </GridComponent>
            )}
          </Col>
        </Row>
      </div>
      <ApprovedStatusModal
        modalOpen={modalOpen}
        toggleModal={toggleModal}
        guid={guid}
      />
    </>
  );
};

export default ListRegisterGrid;
